/* eslint-disable camelcase */
import formatCurrency from 'lib/format-currency';
import translations from 'translations';

/**
 * Maps /analytics/aggs buckets (ISBN agg + include) to list-view table rows.
 */
export default function mapAggrBucketsToUnits(buckets, { currency, languageCode, dataType }) {
  if (!buckets || !buckets.length) return [];

  const isUsage = dataType === 'usage_data';

  let currentTotal = 0;
  let durationTotal = 0;

  buckets.forEach((data) => {
    const {
      current_period: {
        total_revenues: { value },
        total_duration: { value: valueDuration },
      },
    } = data;
    currentTotal += value;
    durationTotal += valueDuration;
  });

  return buckets
    .map((data) => {
      const { key: isbn, current_period, previous_period, include } = data;

      const totalCurrentRevenues = formatCurrency(currency, current_period.total_revenues.value);
      const totalPreviousRevenues = formatCurrency(
        currency,
        previous_period.total_revenues.value,
      );
      const totalCurrentDuration = `${parseFloat(current_period.total_duration.value / 60).toFixed(
        1,
      )} ${translations[languageCode].hours}`;
      const totalPreviousDuration = `${parseFloat(
        previous_period.total_duration.value / 60,
      ).toFixed(1)} ${translations[languageCode].hours}`;

      let percentEarning = 0;
      if (previous_period.total_revenues.value !== 0) {
        percentEarning = Math.round(
          ((current_period.total_revenues.value - previous_period.total_revenues.value) /
            previous_period.total_revenues.value) *
            100,
        );
      }

      let percentTrend = 0;
      if (previous_period.total_duration.value !== 0) {
        percentTrend = Math.round(
          ((current_period.total_duration.value - previous_period.total_duration.value) /
            previous_period.total_duration.value) *
            100,
        );
      }

      let percent = 0;
      percent =
        current_period?.total_revenues?.value !== 0 && currentTotal !== 0
          ? Math.round(current_period.total_revenues.value / (currentTotal / 100))
          : 0;

      let percentDuration = 0;
      percentDuration =
        current_period?.total_duration?.value !== 0 && durationTotal !== 0
          ? Math.round((current_period.total_duration.value * 100) / durationTotal)
          : 0;

      const unitData =
        include?.hits && include.hits.hits && include.hits.hits[0] ? include.hits.hits[0] : null;
      const src = unitData?._source;

      let capitalAuthors = [];
      const authors = src?.authors;
      if (authors && authors.length) {
        capitalAuthors = authors.map((author) => {
          const authorSplit = author.split(' ');
          const capitalName = authorSplit.map(
            (name) => `${name.charAt(0).toUpperCase()}${name.slice(1)}`,
          );
          return capitalName.join(' ');
        });
      }

      const main_category = src?.main_category;
      const language = src?.language;

      return {
        key: isbn,
        totalCurrentRevenuesValue: current_period.total_revenues.value,
        totalCurrentRevenues,
        totalPreviousRevenuesValue: previous_period.total_revenues.value,
        totalPreviousRevenues,
        totalCurrentDoc: current_period.doc_count,
        totalCurrentQuantity: current_period.total_quantity.value,
        totalPreviousQuantity: previous_period.total_quantity.value,
        totalCurrentDuration,
        totalCurrentDurationValue: current_period.total_duration.value,
        totalPreviousDuration,
        percentEarning,
        percent,
        percentTrend,
        percentDuration,
        cover: src?.cover_link,
        title: src?.title || isbn,
        type: src?.item_type,
        publisher: src?.publisher,
        isbn,
        supplier: src?.supplier,
        dataType: src?.data_type,
        publicDomain: src?.public_domain,
        itemType: src?.item_type,
        item_id: src?.item_id,
        authors: capitalAuthors.join(', '),
        genre: main_category && main_category[languageCode] ? main_category[languageCode] : null,
        language: language && language[languageCode] ? language[languageCode] : null,
      };
    })
    .sort((a, b) =>
      isUsage
        ? a.totalCurrentDurationValue - b.totalCurrentDurationValue
        : a.totalCurrentRevenuesValue - b.totalCurrentRevenuesValue,
    )
    .reverse();
}
